module.exports = __webpack_public_path__ + "adbe722e575f670945080738e07778b7.jpg";